/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleRentalDeleteRequest
 */
export interface VehicleRentalDeleteRequest {
    /**
     * ID of the vehicle rental to soft-delete.
     * @type {string}
     * @memberof VehicleRentalDeleteRequest
     */
    id: string;
}

/**
 * Check if a given object implements the VehicleRentalDeleteRequest interface.
 */
export function instanceOfVehicleRentalDeleteRequest(value: object): value is VehicleRentalDeleteRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function VehicleRentalDeleteRequestFromJSON(json: any): VehicleRentalDeleteRequest {
    return VehicleRentalDeleteRequestFromJSONTyped(json, false);
}

export function VehicleRentalDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalDeleteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function VehicleRentalDeleteRequestToJSON(json: any): VehicleRentalDeleteRequest {
    return VehicleRentalDeleteRequestToJSONTyped(json, false);
}

export function VehicleRentalDeleteRequestToJSONTyped(value?: VehicleRentalDeleteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

